<script setup lang="ts">
import Icon from './Icon.vue'
import { useI18n } from '../composables/useI18n'

const { t } = useI18n()
</script>

<template>
  <section class="hero relative min-h-[70vh] bg-gradient-to-b from-base-100 to-base-200">
    <div class="hero-content text-center flex-col max-w-4xl px-4 py-20">
      <img src="/logo.png" :alt="t('hero.logoAlt')" class="w-72 md:w-96 mb-8" />
      <h1 class="text-4xl md:text-6xl font-bold tracking-tight text-base-content">
        {{ t('hero.title') }}
      </h1>
      <p class="text-lg md:text-xl text-base-content/70 mt-4 max-w-2xl">
        {{ t('hero.subtitle') }}
      </p>
      <p class="text-xl md:text-2xl font-semibold text-primary mt-2">
        {{ t('hero.slogan') }}
      </p>
      <div class="flex flex-wrap justify-center gap-3 mt-8">
        <a
          href="https://github.com/Wolido/OpenAaaS"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-primary btn-shine"
        >
          <Icon name="github" iconClass="w-5 h-5" />
          {{ t('hero.github') }}
        </a>
        <a
          href="https://github.com/Wolido/OpenAaaS/releases"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-outline btn-primary"
        >
          <Icon name="download" iconClass="w-5 h-5" />
          {{ t('hero.releases') }}
        </a>
        <a
          href="https://mybinder.org/v2/gh/Wolido/OpenAaaS/main?filepath=binder%2Fquickstart.ipynb"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-soft btn-primary"
        >
          <Icon name="play" iconClass="w-5 h-5" />
          {{ t('hero.binder') }}
        </a>
      </div>

      <a
        href="#pain-points"
        class="hero-scroll-indicator"
        :aria-label="t('hero.scroll')"
      >
        <span class="text-xs text-base-content/50">{{ t('hero.scroll') }}</span>
        <Icon name="chevron-down" iconClass="w-5 h-5 text-primary" />
      </a>
    </div>
  </section>
</template>

<style scoped>
.hero-scroll-indicator {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  animation: hero-bounce 2s ease-in-out infinite;
}

@keyframes hero-bounce {
  0%,
  100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(0.5rem);
  }
}

@media (prefers-reduced-motion: reduce) {
  .hero-scroll-indicator {
    animation: none !important;
  }
}
</style>
